import { render, staticRenderFns } from "./UpdateToolbar.vue?vue&type=template&id=96220750&scoped=true&lang=pug"
import script from "./UpdateToolbar.vue?vue&type=script&lang=js"
export * from "./UpdateToolbar.vue?vue&type=script&lang=js"
import style0 from "./UpdateToolbar.vue?vue&type=style&index=0&id=96220750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96220750",
  null
  
)

export default component.exports